export default __webpack_public_path__ + "static/IN-8015HD_Quick-Installation_P2P-WPS_05-44f50d21910d6abfaa9b9c3d8a8f5bf4.webp";